import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import "./contact.css";

import HeroSection from "./HeroSection";

const FormSection = lazy(() => import("./FormSection"));
const HelpSection = lazy(() => import("./HelpSection"));
const MapSection = lazy(() => import("./MapSection"));

const ContactUs = () => {
  return (
    <>
      <Helmet>
        <title>Contact LENTERA | Get Expert Support & Connect with Us.</title>
        <meta
          name="description"
          content="Reach out to LENTERA for questions, feedback, or personalized business guidance via phone, email, 
          or our contact form. Our expert team provides fast, friendly, and reliable support to help your business succeed."
        />
        <meta
          name="keywords"
          content="LENTERA contact information, business support services, tech consultancy contact."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <FormSection />
        <HelpSection />
        <MapSection />
      </Suspense>
    </>
  );
};

export default ContactUs;
